import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import WaveIcon from '../../../../assets/images/wave_icon.png';

// function WelcomeText() {
//     return (
//         <Box className="welcome-section">
//             <Typography sx={{ fontSize: '1.7rem' }} className="welcome-title">
//                 Welcome! <IconButton className='appbar-icons-button'>
//                     <img src={WaveIcon} alt="cq-logo" width={24} height={24} />
//                 </IconButton>
//             </Typography>
//             <Typography sx={{ fontSize: '1rem' }} className="welcome-subtitle">
//                 Hello! I am Cali Q, Your RGM Expert.
//             </Typography>
//             <Typography sx={{ fontSize: '1rem' }} className="welcome-message">
//                 Feel free to click on any sample question below or ask your own!
//             </Typography>
//         </Box>
//     )
// }

function WelcomeText() {
    // SSO removed: default name
    const firstName = 'Cali';

    return (
        <Box className="welcome-section">
            <Typography sx={{ fontSize: '1.7rem' }} className="welcome-title">
                Get started with AskAsper ✨
                {/* <IconButton className="appbar-icons-button">
                    <img src={WaveIcon} alt="cq-logo" width={24} height={24} />
                </IconButton> */}
            </Typography>
            <Typography sx={{ fontSize: '1rem' }} className="welcome-subtitle">
                Hello! I'm AskAsper, Your RGM Expert. Feel free to click on any sample
            </Typography>
            <Typography sx={{ fontSize: '1rem' }} className="welcome-message">
                question below or ask your own!{' '}
            </Typography>
        </Box>
    );
}

export default WelcomeText;
